// Shared "customer data %" (fill-coverage) helpers used by the demand tables + the
// match-to-sites modal. Kept in their own module so the row components can fast-refresh
// (eslint react-refresh/only-export-components) and to avoid a circular import.

interface FillCoverageMeta {
  latest_full_year_num_rows?: number;
  latest_full_year_num_rows_customer_data?: number;
}

// Fraction of the normalised year that came directly from customer data (rest was gap-filled).
export const customerDataFraction = (
  meta: FillCoverageMeta | undefined
): number | undefined =>
  meta?.latest_full_year_num_rows && meta?.latest_full_year_num_rows_customer_data
    ? meta.latest_full_year_num_rows_customer_data / meta.latest_full_year_num_rows
    : undefined;

export const renderFillCoverageBadge = (fraction: number | undefined) => {
  if (fraction === undefined) return <span className="text-muted">—</span>;
  const pct = fraction * 100;
  // Green >=85, yellow 70-85, red <70 - matches the existing site-level alert at 85%.
  const bg = pct >= 85 ? "success" : pct >= 70 ? "warning" : "danger";
  return (
    <span
      className={`badge bg-${bg}`}
      title={`${pct.toFixed(1)}% of the normalised year is direct customer data; the rest was filled to reach a full year.`}
    >
      {pct.toFixed(0)}%
    </span>
  );
};
